import { inject, Injectable } from '@angular/core';
import { ShortcutsMockApi } from 'app/mock-api/common/shortcuts/api';
import { UserMockApi } from 'app/mock-api/common/user/api';
import { ActivitiesMockApi } from 'app/mock-api/pages/activities/api';
import { IconsMockApi } from 'app/mock-api/ui/icons/api';

@Injectable({ providedIn: 'root' })
export class MockApiService {
    activitiesMockApi = inject(ActivitiesMockApi);
    iconsMockApi = inject(IconsMockApi);
    shortcutsMockApi = inject(ShortcutsMockApi);
    userMockApi = inject(UserMockApi);
}
